import _ from 'lodash';
import { createClient } from '@/shared/api';
import type {
  SentDevicePatientReturnedQuery,
  SentDevicePatientReturnedQueryVariables,
} from '@/shared/api';
import SENT_DEVICE_PATIENT_RETURNED from '../queries/sentDevicePatientReturned';

/**
 * Loads whether a patient-returned notice has already been sent for a device. Runs the sentDevicePatientReturned query for the device id and throws the first GraphQL error only when the result is missing.
 *
 * @param deviceId - Identifier of the device to inspect.
 * @returns A promise resolving to the sent patient-returned payload.
 */
const fetchSentDevicePatientReturned = async (deviceId: any) => {
  const client = createClient();
  const studyResult = await client.query<
    SentDevicePatientReturnedQuery,
    SentDevicePatientReturnedQueryVariables
  >({
    query: SENT_DEVICE_PATIENT_RETURNED,
    variables: {
      deviceId,
    },
  });
  const { data, errors } = studyResult;
  const { sentDevicePatientReturned } = data;
  if (_.isNil(sentDevicePatientReturned) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return sentDevicePatientReturned;
};

export default fetchSentDevicePatientReturned;
